import styled from 'styled-components'
import { breakpoints, colors } from 'style'

export const LRContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: ${(props) => (props.imgPos === 'R' ? 'row-reverse' : 'row')};
  background-color: ${(props) => (props.gray ? '#ECE6E0' : '#fff')};

  align-items: center;
  padding: 25px 0;
  .lr-item {
    h2 {
      font-size: 36px;
      margin-bottom: 45px;
    }
    h4 {
      margin-bottom: 18px;
    }
    a {
      font-size: 18px;
      color: ${colors.blueDark};
    }
    .btn-get-started {
      margin-top: 28px;
    }
    &.lr-content {
      flex: 1;
    }
    &.lr-img {
      flex: 1;
      text-align: ${(props) => (props.imgPos === 'R' ? 'left' : 'right')};
      margin-left: ${(props) => (props.imgPos === 'R' ? '0px' : '30px')};
      margin-right: ${(props) => (props.imgPos === 'R' ? '30px' : '0')};
      img {
        width: 100%;
        max-width: 400px;
      }
    }
  }
  @media (max-width: ${breakpoints.sm}px) {
    flex-direction: column-reverse;
    .lr-item {
      flex: 1;
      h2 {
        margin-bottom: 45px;
        font-size: 32px;
      }
      h4 {
        margin-bottom: 18px;
      }
      a {
        font-size: 18px;
        color: ${colors.blueDark};
      }
      &.lr-img {
        margin-bottom: 35px;
        margin-left: 0;
        margin-right: 0;
      }
    }
  }
  @media (max-width: 413px), (max-height: 845px) {
  }
`
